<script>
    import {M} from "../../external";

    export let onChoice;

    let onDragAndDrop = function() {
        onChoice('drag');
    }

    let onTextEmail = function() {
        onChoice('text');
    }

    let onCustomHtml = function() {
        onChoice('html');
    }

</script>
<div class="col20 f-left flex padding-20 type-of-emails">
    <div class="analytics-box-half" style="margin-right: 0;">
        <div class="col20 f-left addon-select" on:click={onDragAndDrop}>
            <img alt="" class="mt-15" src="https://static.simvoly.com/images/email-drag.png">
            <h3 class="col20 f-left mt-25">{M.DRAG_DROP_BUILDER}</h3>
            <span class="col20 f-left mt-15 mb-15 f-15 light-gray-text">{M.DRAG_DROP_BUILDER_DESC}</span>
            <div class="col20 f-left"><a class="big-button blue">{M.START_NOW}</a></div>
        </div>
    </div>
    <div class="analytics-box-half f-right">
        <div class="col20 f-left addon-select" on:click={onTextEmail}>
            <h3 class="col20 f-left mt-15">{M.TEXT_EMAIL}</h3>
            <span class="col20 f-left mt-15 mb-15 f-15 light-gray-text">{M.TEXT_EMAIL_DESC}</span>
            <div class="col20 f-left"><a class="middle-button blue">{M.START_NOW}</a></div>
        </div>
        <div class="col20 f-left mt-25 addon-select" style="margin-top: 35px !important;" on:click={onCustomHtml}>
            <h3 class="col20 f-left mt-15">{M.CUSTOM_HTML}</h3>
            <span class="col20 f-left mt-15 mb-15 f-15 light-gray-text">{M.CUSTOM_HTML_DESC}</span>
            <div class="col20 f-left"><a class="middle-button blue">{M.START_NOW}</a></div>
        </div>
    </div>
</div>
